import React from "react";

import { useTranslation } from "react-i18next";

import Button from "@components/tailwindComponents/Button";

function BtnFooterPage(props) {
  const { t } = useTranslation("components.buttonModalsFooter");

  return (
    <div className="arh-sticky arh-bottom-0 arh-z-[3] arh-mt-8 arh-w-full arh-bg-greyColor arh-py-8">
      <Button
        className="!arh-w-fit"
        onClick={props.onClick}
        wait={props.loading}
        disabled={props.disabled}
      >
        {t("Enregistrer")}
      </Button>
    </div>
  );
}

export default BtnFooterPage;
